

export function setQueryValue(query: URLSearchParams, key: string, value: string) {
    value ? query.set(key, value) : query.delete(key);
    return query;
}
